<template>
	<div id="select-your-oho-pro">
		<div class="checkout-block rounded mb-4">
			<h3 class="ch-block-title text-left text-uppercase">
				1. SELECT YOUR PACKAGE
			</h3>
			<ul>
				<li
					v-for="(p, index) in packages"
					:key="index"
					class="product-main-list"
				>
					<input
						:id="'group-' + p.id"
						name="product-main"
						type="radio"
						class="product-main-checkbox gtm3_precheckout_pckg"
						:value="p"
						v-model="selectedPackage"
						@change="selectPackage(index)"
					/>
					<label
						:for="'group-' + p.id"
						class="product-options"
						:class="{
							'package-selected': p.id === selectedPackage.id,
						}"
					>
						<!-- Desktop / Tablet -->
						<div
							class="po-container d-none d-lg-flex align-items-center"
						>
							<!-- Checkbox -->
							<span class="check"></span>

							<span
								class="d-flex flex-wrap flex-grow-1 align-items-center"
							>
								<!-- Quantity -->
								<span class="pr-2 font-weight-bold">
									{{ p.quantity }}x
								</span>

								<!-- Name -->
								<span class="mr-3">{{ p.name }}</span>

								<!-- Save box -->
								<span class="po-you-save m-0 mt-1">
									You Save:
									<span class="text-green">{{
										p.prices.priceSaveCurrency.full
									}}</span>
								</span>
							</span>

							<!-- Discount box -->
							<span class="flex-shrink-0 text-right">
								<span class="po-percent-off">
									{{ p.discount_percent }}% OFF
								</span>
							</span>

							<!-- Old price vs New price -->
							<span
								class="po-last d-flex flex-wrap justify-content-end"
							>
								<!-- Old Price -->
								<span class="po-price-old">
									was
									<del>{{
										p.prices.priceOriginalCurrency.full
									}}</del>
								</span>

								<span class="break"></span>

								<!-- New Price -->
								<span class="po-price-new">
									{{ p.prices.priceCurrency.first
									}}<span class="small-price"
										>{{ p.prices.priceCurrency.last }}
									</span>
								</span>
							</span>
						</div>

						<!-- Mobile -->
						<div
							class="po-container-mobile d-flex d-lg-none align-items-center"
						>
							<!-- Check -->
							<span class="check"></span>

							<div class="br-col"></div>

							<!-- Quantity + Name -->
							<span
								class="d-flex flex-column po-name-mobile mr-4"
							>
								<span>
									<b>{{ p.quantity }}x</b>
									{{ p.name }}
								</span>
							</span>

							<div class="br-col"></div>

							<!-- Old price vs New price -->

							<span class="d-flex flex-column ml-auto">
								<!-- Old Price -->
								<span class="po-price-old ml-auto text-right">
									<del>{{
										p.prices.priceOriginalCurrency.full
									}}</del>
								</span>
								<span class="po-price-new ml-auto">
									{{ p.prices.priceCurrency.first
									}}<span class="small-price"
										>{{ p.prices.priceCurrency.last }}
									</span>
								</span>
							</span>
						</div>

						<div class="d-flex align-items-center d-lg-none mt-2">
							<!-- Save box -->
							<span class="po-you-save-mobile">
								You Save:
								<span class="text-green">{{
									p.prices.priceSaveCurrency.full
								}}</span>
							</span>

							<!-- Discount box -->
							<span class="ml-auto">
								<span class="po-percent-off-mobile">
									{{ p.discount_percent }}% OFF
								</span>
							</span>
						</div>
					</label>

					<label
						:for="'group-' + p.id"
						class="most-popular-product"
						v-if="p.promo === true"
						>Best Seller
					</label>
				</li>
			</ul>

			<span class="no-main-product" v-if="!packages.length"
				>There are no products available. Please refresh the page or
				come back later.</span
			>

			<div
				class="d-flex d-md-none justify-content-center pb-4 px-4 px-sm-5"
			>
				<span
					class="sm-cta pulsate-fwd2 my-2 gtm3_precheckout_cta"
					id="cta_mobile1"
					@click="visitCheckout(true)"
					><i class="fas fa-shopping-cart"></i>Proceed To
					Checkout</span
				>
			</div>
		</div>
		<div class="checkout-block rounded mb-4">
			<div class="customize-order" v-if="selectedVariants.length">
				<h4 class="ch-block-title text-uppercase bt-0">
					2. Customize colors &amp; Material
				</h4>

				<div
					class="row align-items-center customize-order-row"
					v-for="(v, i) in selectedVariants"
					:key="i"
				>
					<div class="col-12 col-sm-5 col-md-12 col-lg-5">
						<span class="custom-color-title"
							><b>({{ getNumberWithOrdinal(i + 1) }})</b>
							{{ selectedPackage.name }}</span
						>
					</div>
					<div
						class="col-12 col-sm-7 col-md-12 col-lg-7 mt-3 mb-2 mt-sm-0 mb-sm-0 mt-md-3 mb-md-2 mt-lg-0 mb-lg-0"
					>
						<el-select
							v-model="v.id"
							placeholder="Select a color"
							class="custom-colors-select"
							popper-class="custom-colors-select"
							@change="updatePath"
						>
							<el-option
								v-for="variant in variants"
								:key="variant.id"
								:label="variant.name"
								:value="variant.id"
							>
								<span class="select-color-title">{{
									variant.name
								}}</span>
								<span
									><img
										:src="variant.path"
										class="select-color-image"
								/></span>
							</el-option>
						</el-select>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Select, Option } from "element-ui"

/* NEXT: ADD EXTRAS
 */

export default {
	components: {
		ElSelect: Select,
		ElOption: Option,
	},
	props: {
		products: {
			type: Object,
			default: () => {},
		},
		checkoutPath: {
			type: String,
			default: "https://ohowatch.com",
		},
		beacon: {
			type: Object,
			default: () => {
				return {
					send: false,
					url: "",
				}
			},
		},
	},
	data() {
		return {
			selectedPackage: {},
			selectedVariants: [],
		}
	},
	computed: {
		packages() {
			return this.products.packages
		},
		variants() {
			return this.products.variants
		},
		promo() {
			return this.packages.find((x) => x.promo === true)
		},
		path() {
			let variants = this.selectedVariants.reduce(function (obj, b) {
				obj[b.id] = ++obj[b.id] || 1
				return obj
			}, {})

			let path = ""

			for (const [key, value] of Object.entries(variants, path)) {
				path += key + ":" + value + ","
			}

			return path
		},
	},
	methods: {
		selectPackage(index = null) {
			if (index === null) {
				// If there's a promo package, pre-select it
				if (this.promo !== undefined) {
					this.selectedPackage = this.promo
				} else {
					this.selectedPackage =
						this.packages.find((x) => x !== undefined) || {}
				}
			} else {
				this.selectedPackage = this.packages[index]
			}

			this.addVariants()
			this.updatePath()
		},
		addVariants() {
			this.selectedVariants = null
			this.selectedVariants = []

			// Get the first color/variant
			let firstVariant = this.variants.find((x) => x !== undefined)

			// Generate variants with preselected value
			for (let x = 0; x < this.selectedPackage.quantity; x++) {
				this.selectedVariants.push({
					id: firstVariant.id,
				})
			}
		},
		getNumberWithOrdinal(n) {
			var s = ["th", "st", "nd", "rd"],
				v = n % 100
			return n + (s[(v - 20) % 10] || s[v] || s[0])
		},
		updatePath() {
			this.$emit("changePackage", {
				path: this.path,
				discount: {
					code: this.selectedPackage.discount_code,
					percent: this.selectedPackage.discount_percent,
				},
				costs: parseFloat(this.selectedPackage.prices.priceOriginal),
				savings: parseFloat(this.selectedPackage.prices.priceSave),
			})
		},
		visitCheckout(newTab) {
			if (this.beacon.send && this.beacon.url.length > 3) {
				navigator.sendBeacon(
					"https://trk.topgadgetreport.com/?flux_action=1"
				)
			}
			window.open(this.checkoutPath, newTab == true ? "_blank" : "_self")
		},
	},
	mounted() {
		// Preselect a package
		this.selectPackage()
	},
}
</script>

<style lang="scss" scoped></style>
